export const DateSectionHeader = ({ title }: { title: string }) => (
  <div className="bg-gray-100 dark:bg-gray-800 px-2 py-1 text-xs font-semibold text-gray-600 dark:text-gray-400 border-b border-b-gray-200 dark:border-b-gray-700">
    {title}
  </div>
);
